import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // Core CRUD operations
  async getAllCompetitions(_obj, params) {
    const res = await axios.get(`api/skills-competitions/competitions/`, { params });
    return res.data;
  },

  async getCompetition(_obj, id) {
    const res = await axios.get(`api/skills-competitions/competitions/${id}/`);
    return res.data;
  },

  async createCompetition(_obj, data) {
    const res = await axios.post(`api/skills-competitions/competitions/`, data);
    return res.data;
  },

  async updateCompetition(_obj, { id, data }) {
    const res = await axios.patch(`api/skills-competitions/competitions/${id}/`, data);
    return res.data;
  },

  async updateIsActive(_obj, data) {
    const res = await axios.patch(`api/skills-competitions/competitions/update-is-active/`, data);
    return res.data;
  },

  async deleteCompetition(_obj, id) {
    const res = await axios.delete(`api/skills-competitions/competitions/${id}/`);
    return res.data;
  },

  // Image upload for competitions
  async getCompetitionImageUploadUrl(_obj, data) {
    const res = await axios.post(`api/skills-competitions/competitions/image-upload-url/`, data);
    return res.data.data;
  },

  // Leaderboard functionality
  async getCompetitionLeaderboard(_obj, id) {
    const res = await axios.get(`api/skills-competitions/competitions/${id}/leaderboard/`);
    return res.data;
  },

  // School management
  async getAvailableSchools(_obj, params) {
    const res = await axios.get(`api/skills-competitions/competitions/available_schools/`, { params });
    return res.data;
  },

  async addSchoolToCompetition(_obj, { competitionId, schoolId }) {
    const res = await axios.post(`api/skills-competitions/competitions/${competitionId}/add_school/`, {
      school_id: schoolId
    });
    return res.data;
  },

  async removeSchoolFromCompetition(_obj, { competitionId, schoolId }) {
    const res = await axios.post(`api/skills-competitions/competitions/${competitionId}/remove_school/`, {
      school_id: schoolId
    });
    return res.data;
  },

  // Skillmap management
  async getAvailableSkillmaps(_obj, params) {
    const res = await axios.get(`api/skills-competitions/competitions/available_skillmaps/`, { params });
    return res.data;
  },

  async addSkillmapToCompetition(_obj, { competitionId, skillmapId }) {
    const res = await axios.post(`api/skills-competitions/competitions/${competitionId}/add_skillmap/`, {
      skillmap_id: skillmapId
    });
    return res.data;
  },

  async removeSkillmapFromCompetition(_obj, { competitionId, skillmapId }) {
    const res = await axios.post(`api/skills-competitions/competitions/${competitionId}/remove_skillmap/`, {
      skillmap_id: skillmapId
    });
    return res.data;
  },

  // Student eligibility
  async getEligibleCompetitionsForStudent(_obj, params) {
    const res = await axios.get(`api/skills-competitions/competitions/eligible_for_student/`, { params });
    return res.data;
  },
};

export const skillsCompetitions = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}; 